<template>
  <div class="container">
    <h1>メンテナンス情報の登録・更新</h1>
    <div class="form">
      <div class="alert">
        <v-alert
          v-model="alert"
          border="start"
          variant="tonal"
          closable
          close-label=""
          color="red-accent-4"
          title="登録に失敗しました。"
        >
          {{ alertMsg }}
        </v-alert>
      </div>
      <div class="alert">
        <v-alert
          v-model="success"
          border="start"
          variant="tonal"
          closable
          close-label=""
          color="green-accent-4"
          title="更新に成功しました。"
        >
          更新が完了しました。
        </v-alert>
      </div>
      <v-radio-group v-model="flag">
        <p>メンテナンス情報の表示/非表示</p>
        <v-radio label="表示" :value="true"></v-radio>
        <v-radio label="非表示" :value="false"></v-radio>
      </v-radio-group>
      <div v-if="flag">
        <v-text-field v-model="date" label="日時"></v-text-field>
        <v-text-field v-model="context" label="内容・影響"></v-text-field>
      </div>
      <v-btn class="btn1 bg-blue-lighten-1" @click="update()" :loading="loading"
        >更新</v-btn
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      date: "",
      context: "",
      flag: "",
      loading: false,
      alert: false,
      success: false,
    };
  },
  watch: {
    flag() {
      axios
        .get("https://api.dataplatform-yamanashi.jp/info")
        .then((response) => {
          if (response.data.length == 0) {
            this.date = "";
            this.context = "";
          } else {
            this.date = response.data[0].date;
            this.context = response.data[0].context;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  methods: {
    update() {
      this.loading = true;
      axios
        .post(
          "https://api.dataplatform-yamanashi.jp/info",
          {
            data: {
              infoName: "メンテナンス情報",
              flag: this.flag,
              context: this.context,
              date: this.date,
            },
          },
          { headers: { Authorization: "Bearer " + this.token } }
        )
        .then(() => {
          this.loading = false;
          this.alert = false;
          this.success = true;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.success = false;
          this.alert = true;
        });
    },
  },
  mounted() {
    if (!this.$store.getters.authority) {
      this.$router.push("/");
    }
    axios
      .get("https://api.dataplatform-yamanashi.jp/info")
      .then((response) => {
        if (response.data.length == 0) {
          this.flag = false;
        } else {
          this.flag = true;
          this.date = response.data[0].date;
          this.context = response.data[0].context;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
}

.form {
  width: 80%;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.btn1 {
  width: 20%;
}
</style>
